import React from 'react';

import { SpecCourseLessonViewStubDescription } from 'common.components/spec-course-lesson-view/__stub-description/spec-course-lesson-view__stub-description';
import { SpecCourseLessonViewStubTitle } from 'common.components/spec-course-lesson-view/__stub-title/spec-course-lesson-view__stub-title';
import { SpecCourseLessonViewStub } from 'common.components/spec-course-lesson-view/__stub/spec-course-lesson-view__stub';

import './lesson-view__stub.scss';

export const SpecCourseLessonViewStubInviteStudents = () => {
    return (
        <SpecCourseLessonViewStub mix="spec-course-lesson-view__stub-wrapper">
            <SpecCourseLessonViewStubTitle id="specCourse.LessonView.stub.inviteStudents.title" />
            <SpecCourseLessonViewStubDescription id="specCourse.LessonView.stub.inviteStudents.description" />
        </SpecCourseLessonViewStub>
    );
};
